import { Box, Typography } from '@mui/material';
import { casingFormat, useGetPartnerAccountName } from 'common/utils';
import { capitalize } from 'lodash';
import PropTypes from 'prop-types';

const AssociationDetailsTab = ({ order }) => {
  const partnerAccountHandler = useGetPartnerAccountName();

  const getPartnerAccountName = (partnerAccountId) => {
    return partnerAccountId && partnerAccountHandler[partnerAccountId]
      ? capitalize(partnerAccountHandler[partnerAccountId].partnerAccountName)
      : 'N/A';
  };
  const infoFields = [
    {
      label: 'Partner',
      value: casingFormat(order?.partner?.partnerName) || 'N/A',
    },
    {
      label: 'Practice',
      value: casingFormat(order?.practice?.practiceName) || 'N/A',
    },
    {
      label: 'PartnerAccount',
      value: getPartnerAccountName(order.partnerAccountId) || 'N/A',
    },
  ];
  return (
    <Box sx={{ ml: '25px' }}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Box>
          {infoFields?.map((field) => (
            <Typography key={field.label} variant='subtitle2' gutterBottom>
              {field.label}
            </Typography>
          ))}
        </Box>
        <Box>
          {infoFields?.map((field) => (
            <Typography key={field.label} variant='subtitle2' gutterBottom>
              :
            </Typography>
          ))}
        </Box>
        <Box>
          {infoFields?.map((field) => (
            <Typography key={field.label} variant='body2' sx={{ fontWeight: 600 }} gutterBottom>
              {field.value}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

AssociationDetailsTab.propTypes = {
  order: PropTypes.shape({
    partner: PropTypes.shape({
      partnerName: PropTypes.string,
    }),
    practice: PropTypes.shape({
      practiceName: PropTypes.string,
    }),
    partnerAccountId: PropTypes.string,
  }).isRequired,
};

export default AssociationDetailsTab;
